<!-- Enable for debuging -->
<div *ngIf="false">
    <p>
        App Check!
        <code>{{ (change$ | async)?.token | slice:0:12 }}<ng-container *ngIf="(change$ | async) !== null">&hellip;</ng-container></code>
    </p>
</div>